/* eslint-disable import/no-anonymous-default-export */

import { SELECT_OFFICER_TYPE } from "../Action";

const initialState = {
  selectOfficerType: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_OFFICER_TYPE:
      return {
        ...state,
        selectOfficerType: action.payload,
      };

    default:
      return state;
  }
}
